import { useMutation, UseMutationOptions } from "react-query";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";

type MerchantBankDeleteResponse = BaseResponse<null>;

const deleteMerchantBank = async (id: number): Promise<MerchantBankDeleteResponse> => {
  const { data } = await axiosInstance.delete<MerchantBankDeleteResponse>(`/MerchantBank/Delete?id=${id}`);
  return data;
};

export const useMerchantBankDelete = (
  options?: UseMutationOptions<MerchantBankDeleteResponse, unknown, number>
) => {
  return useMutation("deleteMerchantBank", deleteMerchantBank, options);
};
